import { DialogActions as Mui4DialogActions, DialogActionsProps as Mui4DialogActionsProps } from '@material-ui/core'
import { default as Mui5DialogActions, DialogActionsProps as Mui5DialogActionsProps } from '@mui/material/DialogActions'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsDialogVersion } from './Dialog'

export type DialogActionsProps = Mui4DialogActionsProps & {
  sx?: Mui5DialogActionsProps['sx']
}
/** @deprecated Use DialogActionsProps */
export type OsDialogActionsProps = DialogActionsProps

export const DialogActions = forwardRef<HTMLDivElement, DialogActionsProps>((props, ref) => {
  const version = useComponentVersion('dialog')
  switch (version) {
    case OsDialogVersion.V2:
      return <Mui5DialogActions ref={ref} {...props} />

    default:
      return <Mui4DialogActions ref={ref} {...props} />
  }
})
